<template>
  <svg-icon name="Msg-Success" size="16px"></svg-icon>
</template>
